import React, { useContext } from 'react'
import cn from 'classnames'
import { AudioContext } from 'rewact'
import * as Icon from '../Icons'

import styles from './app.module.css'

function SelectedItems({
  selectionState,
  itemsToUnselect,
  setItemsToUnselect,
  setPlayerTrack,
  playerTrack,
  query,
  setQuery,
  setCurrentPage,
}) {
  const { isPaused, play, pause } = useContext(AudioContext)
  return (
    <ul className={styles.tracksSelectionList}>
      {Object.keys(selectionState).length > 0 ? (
        Object.keys(selectionState).map((slug) => {
          const checked = itemsToUnselect.includes(slug)
          const active = selectionState[slug].slug === playerTrack.slug
          const item = selectionState[slug]
          return (
            <li
              className={cn(
                styles.tracksPlayerItem,
                styles.tracksSelectionItem,
                {
                  [styles.checked]: checked,
                  [styles.active]: active,
                }
              )}
              key={slug}
              onClick={(e) => {
                if (!active) {
                  setPlayerTrack(selectionState[slug])
                  setTimeout(() => play(), 100)
                } else {
                  setTimeout(() => {
                    if (isPaused) {
                      play()
                    } else {
                      pause()
                    }
                  }, 100)
                }
              }}
            >
              <div className={styles.tracksSelectionItemArtifacts} />
              <div className={styles.tracksPlayerImage}>
                {item.image ? (
                  <img
                    alt={`${item.name} by ${item.artist}`}
                    src={`${process.env.REACT_APP_COVER_URI}/s/${item.image}`}
                    className={styles.tracksPlayerImageImg}
                  />
                ) : (
                  <Icon.Placeholder style={{ color: '#ff3b57' }} />
                )}
                <div className={styles.tracksPlayerImagePlayBtn}>
                  {active && !isPaused ? (
                    <Icon.Pause />
                  ) : (
                    <Icon.Play style={{ marginLeft: 2 }} />
                  )}
                </div>
              </div>
              <div className={styles.tracksPlayerInfo}>
                <p
                  className={cn(
                    styles.tracksPlayerInfoName,
                    styles.tracksFilterItemText
                  )}
                >
                  {item.name}
                </p>
                <p
                  className={styles.tracksPlayerInfoArtist}
                  onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    // Already exists Artist in Tags List
                    if (
                      !query['artist'] ||
                      (query['artist'] &&
                        !query['artist'].includes(item.artist))
                    ) {
                      setCurrentPage(1)
                      setQuery((query) => ({
                        ...query,
                        artist: [
                          item.artist,
                          // ...new Set([
                          //   ...(query['artist'] ? query['artist'] : []),
                          //   item.artist,
                          // ]),
                        ],
                      }))
                    }
                  }}
                >
                  {item.artist}
                </p>
              </div>

              <input
                id={`selection_${slug}`}
                type="checkbox"
                name={`selection_${slug}`}
                className={styles.selectionCheckbox}
              />
              <label
                htmlFor={`selection_${slug}`}
                className={cn(styles.selectionLabel, {
                  [styles.checked]: checked,
                })}
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  if (checked) {
                    setItemsToUnselect((items) => {
                      return items.filter((sel) => sel !== slug)
                    })
                  } else {
                    setItemsToUnselect((items) => {
                      return [...items, slug]
                    })
                  }
                }}
              >
                <Icon.Check className={styles.selectionLabelCheck} />
              </label>
            </li>
          )
        })
      ) : (
        <li
          className={cn(styles.tracksSelectionItem, styles.empty)}
          style={{ display: 'inline-block' }}
        >
          <p
            style={{
              color: '#737377',
              fontSize: 16,
              margin: 0,
              paddingLeft: 20,
            }}
          >
            No songs selected yet.
          </p>
        </li>
      )}
    </ul>
  )
}

export default SelectedItems
